/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

import ServicePath from "@/core/ServicePath"
import {
    MainRequest
} from "@/core/request";

export default class InterpretationHistoryRequest extends MainRequest {

    static listAll() {}
    static listAllInterpretedByModalityAndBranchOffice(data) {
        return this.postSEC(ServicePath.INTERPRETATION_HISTORY_LIST_ALL_BY_MODALITY_AND_BRANCH_OFFICE, data);
    }
    static listAllInterpretedBySpeciality(data) {
        return this.postSEC(ServicePath.INTERPRETATION_HISTORY_LIST_ALL_BY_SPECIALITY, data);
    }
    static getInterpretationById(data) {
        return this.postSEC(ServicePath.INTERPRETATION_GET_BY_ID, data);
    }

    static add(object) {}
    static update(object) {}

    static editFilesColposcopyFromInterpretation(params) {
        return this.postSEC(ServicePath.INTERPRETATION_EDIT_FILES, params);
      }
      static editFormColposcopyFromInterpretation(params) {
        return this.postSEC(ServicePath.INTERPRETATION_EDIT_FORM, params);
      }

    static getAddendums(data) {
        return this.postSEC(ServicePath.INTERPRETATION_GET_ADDENDUMS, data);
    }

    static getOneAddendum(data) {
        return this.postSEC(ServicePath.INTERPRETATION_GET_ONE_ADDENDUM, data);
    }

    static deleteOneAddendum(data) {
        return this.postSEC(ServicePath.INTERPRETATION_DELETE_ONE_ADDENDUM, data);
    }

    static getCountPendingByBranchOffice(data) {
        return this.postSEC(ServicePath.INTERPRETATION_COUNT_PENDING_BY_BRANCH_OFFICE, data);
    }

    static addOneAddendum(data) {
        return this.postSEC(ServicePath.INTERPRETATION_SAVE_FILE, data);
    }

    static allByInterpretation(data) {
        return this.postSEC(ServicePath.INTERPRETATION_HISTORY_BY_ID_INTERPRETATION, data)
    }


}